import React from "react";
import { Grid, Typography } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import GlobalContext from "../../../../Context/GlobalContext";
import BoutiqueEnligne from "./Boutique/Boutique";
import Calendrier from "./Calendrier/Calendrier";
import Offres from "./Offres/Offres";
import Videos from "./Videos/Videos";
import axios from "../../../../Utils/axios";
import LoadingPage from "../../../../components/Loading/LoadingComponent";
import styles from "./ProfileIntervenant.module.css";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import arrowDown from "../../../../Assets/images/ChevronDoubleDown.png";
import { useTranslation } from "react-i18next";

const TypographyWithStyle = ({ variant, style, children }) => (
  <Typography variant={variant} style={style}>
    {children}
  </Typography>
);

const SectionHeader = ({ title, subtitle, isSmallScreen }) => (
  <>
    <TypographyWithStyle
      variant="h4"
      style={{
        color: " #3F4C52",
        textAlign: "center",
        fontFamily: "DM Serif Display",
        fontSize: isSmallScreen ? "1.5rem" : "3.5rem",
        fontStyle: "normal",
        fontWeight: 400,
      }}>
      {title}
    </TypographyWithStyle>
    <TypographyWithStyle
      variant="h3"
      style={{
        color: " #2E2E2E",
        textAlign: "center",
        fontFamily: "Lato",
        fontSize: isSmallScreen ? "1.1rem" : "1.5rem",
        fontStyle: "normal",
        fontWeight: 400,
      }}>
      {subtitle}
    </TypographyWithStyle>
  </>
);

function ProfilIntervenant() {
  const context = React.useContext(GlobalContext);

  const [userData, setUserData] = React.useState(null);
  const [categories, setCategories] = React.useState(null);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const location = useLocation();
  const { t } = useTranslation();

  React.useEffect(() => {
    console.log("Page Loaded, Scroll to Top");
    window.scrollTo(0, 0);
  }, []);

 
React.useEffect(() => {
  const savedProfile = JSON.parse(
    localStorage.getItem("selectedIntervenantProfile")
  );

  if (!savedProfile?.[0]?.id_user) return;

  const refreshProfile = async () => {
    try {
      const response = await axios.get(
        `/public/intervenant/profile/${savedProfile[0].id_user}`
      );

      const updatedProfile = response.data.result;

      setUserData(updatedProfile);

      localStorage.setItem(
        "selectedIntervenantProfile",
        JSON.stringify(updatedProfile)
      );
    } catch (error) {
      console.error("Erreur refresh profil :", error);
    }
  };

  refreshProfile();
}, []);
  
 
React.useEffect(() => {
  if (context.selectedIntervenantProfile) {
    setUserData(context.selectedIntervenantProfile);
  } else {
    const userProfile = JSON.parse(
      localStorage.getItem("selectedIntervenantProfile")
    );

    if (userProfile) {
      setUserData(userProfile);
    }
  }

  const categoryData = JSON.parse(
    localStorage.getItem("categories")
  );

  if (categoryData) {
    setCategories(categoryData);
  }
}, [context.selectedIntervenantProfile]);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const message = queryParams.get("message");

    // Show toast only when the 'message' changes
    if (message === "canceled") {
      toast.info("Votre commande a été annulée");
    } else if (message === "success") {
      toast.success("Votre commande a été valider");
    }
  }, [location.search]);

  if (!userData || !categories) {
    return <LoadingPage />;
  }

  return (
    <div>
      <section className={styles["section-description"]}>
        <Grid container spacing={2} alignItems="center">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <Grid item xs={12} sm={6}>
            <div
              style={{
                textAlign: "center",
                position: "relative",
                width: "fit-content",
                margin: "0 auto",
              }}>
              {/* Badge de disponibilité (Positionné sur l'image) */}
              <div
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px", // Ajusté pour être à l'intérieur du cercle comme sur la photo
                  zIndex: 2,
                  padding: "6px 14px",
                  borderRadius: "30px",
                  fontSize: "13px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor:
                    userData[0].availability_user === 1 ? "#53B1A6" : "#f3a109", // Couleur teal pour Online
                  color: "#FFFFFF",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}>
                {/* Le point blanc avec le centre coloré */}
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <span
                    className={
                      userData[0].availability_user === 1
                        ? styles["clignote"]
                        : ""
                    }
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor:
                        userData[0].availability_user === 1
                          ? "#06f762"
                          : "#e9a410", // Rouge si en ligne (selon l'image)
                    }}></span>
                </span>

                {userData[0].availability_user === 1 ? "En ligne" : "Sur RDV"}
              </div>

              {/* Image de l'utilisateur (Cercle parfait) */}
              <img
                alt="Profile"
                src={`${process.env.REACT_APP_APIURL}/storage/workshop/${userData[0].photo_user}`}
                style={{
                  display: "block",
                  width: "220px", // Taille adaptée à votre maquette
                  height: "220px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #FFFFFF",
                }}
              />

              {/* Titre de l'utilisateur */}
              <div
                style={{
                  marginTop: "20px",
                  fontWeight: "800",
                  color: "#2B3674",
                  fontSize: "1.3rem",
                  textTransform: "capitalize",
                  fontFamily: "inherit",
                }}>
                {userData[0].title_user}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={styles["description"]}>
              <TypographyWithStyle
                variant="h4"
                style={{
                  color: " #3F4C52",
                  textAlign: "left",
                  fontFamily: "DM Serif Display",
                  fontSize: isSmallScreen ? "1.5rem" : "2.5rem",
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                {userData[0].nom_user} {userData[0].prenom_user}
              </TypographyWithStyle>

              <TypographyWithStyle
                variant="p"
                style={{
                  color: " #2E2E2E",
                  textAlign: "left",
                  fontFamily: "Lato",
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: 400,
                }}>
                {userData[0].description_user}
              </TypographyWithStyle>

              <div className={styles["div-speciality"]}>
                {[
                  ...(userData[0]?.specialities?.map((s) => s?.specialty) ||
                    []),
                  userData[0]?.main_speciality_user,
                ]
                  .filter(Boolean)
                  .flatMap((specialty) =>
                    specialty.split(",").map((s) => s.trim()),
                  )
                  // --- AJOUTEZ CETTE LIGNE POUR SUPPRIMER LES DOUBLONS ---
                  .filter((value, index, self) => self.indexOf(value) === index)
                  // ------------------------------------------------------
                  .map((specialty, index) => (
                    <span className={styles["speciality-span"]} key={index}>
                      {specialty}
                    </span>
                  ))}
              </div>
            </div>
          </Grid>
        </Grid>
        <div style={{ marginTop: "50px" }}>
          <img src={arrowDown} alt="arrow_Down" className="arrowDown center" />
        </div>
      </section>

      <section className={styles["bg-section-boutique"]}>
        <BoutiqueEnligne userData={userData[0]} />
      </section>

      <section className={styles["section-reservation"]}>
        <SectionHeader
          title={t("reservationSubtitle")}
          subtitle={t("reservationTitle")}
          isSmallScreen={isSmallScreen}
        />
        <br></br>

        <Calendrier userData={userData[0]} />
      </section>

      <section className={styles["section-consultation"]}>
        <SectionHeader
          title={t("consultationTitle")}
          subtitle={t("consultationSubtitle")}
          isSmallScreen={isSmallScreen}
        />
        <br></br>
        <Offres userData={userData[0]} Categories={categories} />
      </section>

      <section
        className={styles["section-videos"]}
        style={{ padding: "5% 10%" }}>
        <SectionHeader title={t("videosTitle")} isSmallScreen={isSmallScreen} />

        <Videos userData={userData[0]} />
      </section>
    </div>
  );
}

export default ProfilIntervenant;
